import { JobNotFoundErrorMessage, useNotifications } from "@relode/core";
import * as React from "react";
import { JobActions } from "./jobActions";
import { JobState } from "./jobState";

export const useJobErrorHandlers = (state: JobState, actions: JobActions) => {
    const { actions: notifications } = useNotifications();
    const {
        ui: { error },
    } = state;

    React.useEffect(() => {
        if (!error) return; // we don't close from here.  might be odd

        const message =
            error.message ??
            error.apiError?.friendlyMessages ??
            "we've encountered a problem";

        switch (error.type) {
            case "loadJobFailure": {
                notifications.showModal(
                    "error",
                    "job not found",
                    JobNotFoundErrorMessage(message),
                    {
                        canClose: false,
                    }
                );
                break;
            }
            case "loading": {
                notifications.showArea("error", message, "loadJob", {
                    canClose: false,
                });
                break;
            }
            case "suggestionsLoading": {
                notifications.showArea("error", message, "manageTeamMembers", {
                    canClose: false,
                });
                break;
            }
            default: {
                if (error.apiError.summary) {
                    notifications.showModal("error", "we're sorry", message, {
                        callback: () => {
                            actions.clearError();
                        },
                    });
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);
};
